@if (preLog) {
  <div class="row">
    <div class="py-2 col-4 col-sm-3 col-lg-2">Kit Barcode #:</div>
    <div class="py-2 col-8 col-sm-3 col-lg-2 bold-label">{{ preLog.kitBarcode }}</div>
    @if (showVACORISNumber) {
      <div class="py-2 col-4 col-sm-3 col-lg-2">VACORIS #:</div>
      <div class="py-2 col-8 col-sm-3 col-lg-2 bold-label">{{ preLog.docNumber }}</div>
    }
  </div>
}
@if (preLog) {
  <div class="row">
    <div class="py-2 col-4 col-sm-3 col-lg-2">Date Entered:</div>
    <div class="py-2 col-8 col-sm-3 col-lg-2 bold-label">{{ renderDate(preLog.dateEntered) }}</div>
    <div class="py-2 col-4 col-sm-3 col-lg-2">Entered By:</div>
    <div class="py-2 col-8 col-sm-3 col-lg-2 bold-label">{{ preLog.enteredBy }}</div>
    <div class="py-2 col-4 col-sm-3 col-lg-2">Agency Name:</div>
    <div class="py-2 col-8 col-sm-3 col-lg-2 bold-label">{{ preLog.agencyName }}</div>
  </div>
}
@if (preLog) {
  <div class="row">
    <div class="py-2 col-4 col-sm-3 col-lg-2">Last Name:</div>
    <div class="py-2 col-8 col-sm-9 col-lg-6 bold-label">{{ preLog.lastName }}</div>
    <div class="py-2 col-4 col-sm-3 col-lg-2">First Name:</div>
    <div class="py-2 col-8 col-sm-9 col-lg-2 bold-label">{{ preLog.firstName }}</div>
    <div class="py-2 col-4 col-sm-3 col-lg-2">Middle Initial:</div>
    <div class="py-2 col-8 col-sm-3 col-lg-2 bold-label">{{ preLog.middleInitial }}</div>
    <div class="py-2 col-4 col-sm-3 col-lg-2">Suffix:</div>
    <div class="py-2 col-8 col-sm-3 col-lg-2 bold-label">{{ preLog.nameSuffix }}</div>
    <div class="py-2 col-4 col-sm-3 col-lg-2">Aliases:</div>
    <div class="py-2 col-8 col-sm-9 col-lg-2 bold-label">{{ renderAliases(preLog.aliases) }}</div>
  </div>
}
@if (preLog) {
  <div class="row">
    <div class="py-2 col-4 col-sm-3 col-lg-2">Gender:</div>
    <div class="py-2 col-8 col-sm-3 col-lg-2 bold-label">{{ preLog.gender }}</div>
    <div class="py-2 col-4 col-sm-3 col-lg-2">Race:</div>
    <div class="py-2 col-8 col-sm-3 col-lg-2 bold-label">{{ preLog.race }}</div>
  </div>
}
@if (preLog) {
  <div class="row">
    <div class="py-2 col-4 col-sm-3 col-lg-2">Date of Birth:</div>
    <div class="py-2 col-8 col-sm-3 col-lg-2 bold-label">{{ renderDate(preLog.dateOfBirth) }}</div>
    <div class="py-2 col-4 col-sm-3 col-lg-2">SSNs:</div>
    <div class="py-2 col-8 col-sm-3 col-lg-2 bold-label">{{ preLog.ssn }}</div>
    <div class="py-2 col-4 col-sm-3 col-lg-2">SID#:</div>
    <div class="py-2 col-8 col-sm-3 col-lg-2 bold-label">{{ preLog.sid }}</div>
  </div>
}
@if (preLog) {
  <div class="row">
    <div class="py-2 col-4 col-sm-3 col-lg-2">Reason for Collection:</div>
    <div class="py-2 col-8 col-sm-3 col-lg-2 bold-label">{{ preLog.reasonForCollection }}</div>
    <div class="py-2 col-4 col-sm-3 col-lg-2">Qualifying Charge:</div>
    <div class="py-2 col-8 col-sm-3 col-lg-2 bold-label">{{ preLog.qualifyingCharge }}</div>
    @if (this.preLog && this.preLog.state) {
      <div class="py-2 col-4 col-sm-3 col-lg-2">State:</div>
      <div class="py-2 col-8 col-sm-3 col-lg-2 bold-label">{{ preLog.state }}</div>
    }
  </div>
}
@if (preLog && preLog.arrestingOfficer) {
  <div class="row">
    <div class="py-2 col-4 col-sm-3 col-lg-2">Arresting Officer:</div>
    <div class="py-2 col-8 col-sm-3 col-lg-2 bold-label">{{ preLog.arrestingOfficer }}</div>
    <div class="py-2 col-4 col-sm-3 col-lg-2">DCN:</div>
    <div class="py-2 col-8 col-sm-3 col-lg-2 bold-label">{{ preLog.dcn }}</div>
  </div>
}
@if (preLog) {
  <div class="row">
    <div class="py-2 col-4 col-sm-3 col-lg-2">Date Collected:</div>
    <div class="py-2 col-8 col-sm-3 col-lg-2 bold-label">{{ renderDate(preLog.dateCollected) }}</div>
    <div class="py-2 col-4 col-sm-3 col-lg-2">Sample Collected By:</div>
    <div class="py-2 col-8 col-sm-3 col-lg-2 bold-label">{{ preLog.collectedBy }}</div>
  </div>
}
